import { TypesService } from './types.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { TypesDTO } from './dto/types.dto';
import { AllTypesResponse, CommonResponse, ItemSubCategoryRequest, TypesDto, TypesResponse } from '@gtpl/shared-models/masters';
import { TypesRequest } from './dto/types.request';
import { Types } from './types.entity';

@Controller('types')
export class TypesController {
    constructor(
        private typesService: TypesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) { }
    /**
     * creates  a Notify Party
     * @param typesDto Types DTO
     * @returns  TypesResponse
     */
    @Post('/createTypes')
    async createTypes(@Body() TypesDTO: TypesDTO): Promise<TypesResponse> {
        try {
            return await this.typesService.createTypes(TypesDTO, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(TypesResponse, error);
        }
    }
    /**
     * gets all the Value Notify Party
     * @returns AllTypesResponse which returns all the Value notify-Party  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */
    @Post('/getAllTypes')
    async getAllTypes(): Promise<AllTypesResponse> {
        try {
            return await this.typesService.getAllTypes();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllTypesResponse, error);
        }
    }

    /**
   * Activate Or De-Activate Value Types
   * @param getSingleTypes Types
   * @returns Value Types
   */
    @Post('/activatedeActivateTypes')
    async activatedeActivateTypes(@Body() TypesReq: TypesRequest): Promise<TypesResponse> {
        try {
            return await this.typesService.activateOrDeactivateTypes(TypesReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(TypesResponse, err);
        }
    }
    /**
  *  updates a  value Notify Party
  * @param TypesDto Notify Party DTO
  * @returns TypesResponse
  */
     @Post('/updateTypes')
     async updateTypes(@Body() TypesDTO:TypesDTO): Promise<TypesResponse> {
         try {
          return await this.typesService.createTypes(TypesDTO,true);
        } catch (error) {
             return this.applicationExceptionHandler.returnException(TypesResponse, error);
        }
      }
      @Post('/getAllTypesDropDown')
      async getAllTypesDropDown():Promise<CommonResponse>{
         try {
             return await this.typesService.getAllTypesDropDown();
         } catch (err) {
             return this.applicationExceptionHandler.returnException(CommonResponse, err);
         }
      }
 
      @Post('/getTypesInfoById')
      async getTypesById(@Body() typesReq: TypesRequest):Promise<Types>{
         try {
             return await this.typesService.getTypesById(typesReq.typeId);
         } catch (err) {
            return err;
         }
       }
       
    @Post('/getTypesInfoById')
     async getTypesInfoById(@Body() typesReq: TypesRequest):Promise<CommonResponse>{
        try {
            return await this.typesService.getTypesInfoById(typesReq.typeId);
        } catch (err) {
          return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
      }

      @Post('/getTypesForItemSubcategoryId')
      async getTypesForItemSubcategoryId(@Body() req : ItemSubCategoryRequest):Promise<CommonResponse>{
         try {
             return await this.typesService.getTypesForItemSubcategoryId(req);
         } catch (err) {
           return this.applicationExceptionHandler.returnException(CommonResponse, err);
         }
       }
}
